import { render, staticRenderFns } from "./ContainerSingle.vue?vue&type=template&id=2109238f&scoped=true&"
import script from "./ContainerSingle.vue?vue&type=script&lang=js&"
export * from "./ContainerSingle.vue?vue&type=script&lang=js&"
import style0 from "./ContainerSingle.vue?vue&type=style&index=0&id=2109238f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109238f",
  null
  
)

export default component.exports